module.exports = __webpack_public_path__ + "static/capability-organic-search-2-11231597670aa11d1615ee345c2af3cb.png";